import Vue from 'vue'
// models component
import App from '@/models/App'
import SelectOrganization from '@/models/SelectOrganization'
import ShipLaborAttendance from '@/models/ShipLaborAttendance'
import ShipLaborWork from '@/models/ShipLaborWork'
import ShipSailor from '@/models/ShipSailor'

export default class AtttendMemberInitialize {
    // Ship Management Service Initialize
    static of(shipId, shipSailorId, shipLaborBoardingId) {
        return Promise.resolve()
            .then(function () {
                SelectOrganization.deleteAll()
                return SelectOrganization.api()
                    .fetch()
                    .then(function (result) {
                        // console.log('SelectOrganization.all()', SelectOrganization.all())
                    })
            })
            .then(function () {
                if (shipLaborBoardingId) {
                    ShipLaborAttendance.deleteAll()
                    return ShipLaborAttendance.api()
                        .attendFetch(shipSailorId)
                        .then(function (result) {
                            // console.log('ShipLaborAttendance.all()', ShipLaborAttendance.all())
                        })
                }
            })
            .then(function () {
                // console.log('shipLaborWork fetch', shipId)
                if (shipId) {
                    ShipLaborWork.deleteAll()
                    return ShipLaborWork.api()
                        .fetch(shipId)
                        .then(function (result) {
                            // console.log('ShipLaborWork.all() from member.js', ShipLaborWork.all())
                        })
                }
            })
            .then(function () {
                if (shipId) {
                    ShipSailor.deleteAll()
                    return ShipSailor.api()
                        .find(shipId, shipSailorId)
                        .then(function (result) {
                            // console.log('ShipSailor.all() from member.js', ShipSailor.all())
                        })
                }
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
